export var AIAgent;
(function (AIAgent) {
    AIAgent["CLAUDE"] = "Claude";
    AIAgent["CHAT_GPT"] = "ChatGPT";
    AIAgent["MS_COPILOT"] = "MSCopilot";
    AIAgent["OPEN_EVIDENCE"] = "OpenEvidence";
    AIAgent["PERPLEXITY"] = "Perplexity";
    AIAgent["META"] = "Meta";
    AIAgent["OPTUM"] = "Optum";
    AIAgent["ADVENT"] = "Advent";
    AIAgent["WHOOP"] = "Whoop";
})(AIAgent || (AIAgent = {}));
